import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DireccionControllerService } from 'api-rest';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { Domicilio } from '../../../models/domicilio';
import swal from 'sweetalert2';
import { CollectionPointsManagersAddressDialogComponent } from '../collection-points-managers-address-dialog/collection-points-managers-address-dialog.component';

@Component({
  selector: 'app-collection-points-managers-address-data',
  templateUrl: './collection-points-managers-address-data.component.html',
  styleUrls: ['./collection-points-managers-address-data.component.scss'],
})
export class CollectionPointsManagersAddressDataComponent implements OnInit {
  @Input() puntoRecogidaInfo!: any;
  @Output() public refrescarPuntosRecogidaEvent = new EventEmitter<any>();
  direcciones: any;

  gridArray: any[] = [];

  headArray: any = [
    {
      Head: 'Requerida',
      FieldName: 'requerido',
      check: true,
      disabled: true,
      width: '1',
    },
    {
      Head: 'Tipo direccion',
      FieldName: 'tipoDireccion',
      Attribute: 'descripcion',
      width: '2',
    },
    {
      Head: 'Dirección',
      FieldName: 'fullAddress',
      Tooltip: true,
      width: '8',
      Maxtext: 50,
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '2',
    },
  ];

  constructor(
    private dialog: MatDialog,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private direccionControllerService: DireccionControllerService
  ) {}

  ngOnInit(): void {}

  canAccessNewAddress(): boolean {
    return (
      this.authService.can('ptosrecogida-gestor-direcciones', 'create') &&
      this.puntoRecogidaInfo?.estado! &&
      [1, 2, 3].includes(this.puntoRecogidaInfo?.estado?.id!)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.puntoRecogidaInfo) {
      this.direcciones = this.puntoRecogidaInfo?.domicilios;
      this.gridArray = this.canAccessAll(this.direcciones);
    }
  }

  canAccessAll(list: any) {
    const resultListShow = this.authService.can(
      'ptosrecogida-gestor-direcciones',
      'access'
    );
    const resultListEdit = this.authService.can(
      'ptosrecogida-gestor-direcciones',
      'update'
    );
    const resultDelete = this.authService.can(
      'ptosrecogida-gestor-direcciones',
      'delete'
    );

    const listPermission = list.map((objeto: any) => {
      const estadoUpdatedAddress =
        this.puntoRecogidaInfo?.estado &&
        [1, 2, 3].includes(this.puntoRecogidaInfo?.estado?.id!);
      const estadoEliminar =
        this.puntoRecogidaInfo?.estado &&
        [1, 2].includes(this.puntoRecogidaInfo?.estado?.id!) &&
        (!objeto.requerido || objeto.requerido === null);

      return {
        ...objeto,
        canAccessView: resultListShow,
        canAccessListEdit: resultListEdit && estadoUpdatedAddress,
        canAccessDelete: resultDelete && estadoEliminar,
      };
    });

    return listPermission;
  }

  abrirModalDirecciones(element?: Domicilio): void {
    const dialogRef = this.dialog.open(
      CollectionPointsManagersAddressDialogComponent,
      {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          direccion: element,
          puntoRecogidaInfo: this.puntoRecogidaInfo,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarPuntosRecogidaEvent.emit(true);
      }
    });
  }

  confirmacionEliminar(element?: Domicilio): void {
    swal
      .fire({
        text: '¿Desea eliminar la dirección?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.eliminarDireccion(element);
        }
      });
  }
  eliminarDireccion(element?: Domicilio) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.direccionControllerService.borrarDireccion(element.id).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.refrescarPuntosRecogidaEvent.emit(true);
          this.snackBarSrv.showSnackBar(
            'La dirección se ha eliminado correctamente',
            'success'
          );
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar la dirección',
            'error'
          );
          console.log(err);
        },
      });
    }
  }

  action(item: any) {
    if (item.nameButton == 'view') {
      this.abrirModalDirecciones(item);
    } else if (item.nameButton == 'edit') {
      this.abrirModalDirecciones(item);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(item);
    }
  }
}
